import { render, staticRenderFns } from "./signContract.vue?vue&type=template&id=55d1da12&scoped=true&"
import script from "./signContract.vue?vue&type=script&lang=js&"
export * from "./signContract.vue?vue&type=script&lang=js&"
import style0 from "./signContract.vue?vue&type=style&index=0&id=55d1da12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d1da12",
  null
  
)

export default component.exports